import apiFetch from '../apiFetch'

export default function (dossierInfo, token) {
  return apiFetch({ endPoint: 'StructureGenerator', method: 'POST', body: dossierInfo, isHotFolder: true, token: token })
}
